import { API_CLIENT } from "../config";
import { getAPIConfigs } from "../helpers";

import {
  VersionCategoryRaw,
  VersionCategoryRawForm,
} from "@/domain/VersionCategories";

const apiUrlVersionCategories = "/version_categories";

// 組織IDを指定してカテゴリ一覧を取得
export const getVersionCategories = async ({
  organizationId,
}: {
  organizationId: string;
}): Promise<VersionCategoryRaw[]> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.get<{ items: VersionCategoryRaw[] }>(
    `${apiUrlVersionCategories}`,
    {
      ...apiOrganizationIdParams,
    }
  );
  return response.data.items;
};

// 個別のカテゴリを取得
export const getVersionCategory = async ({
  versionCategoryId,
  organizationId,
}: {
  versionCategoryId: VersionCategoryRaw["id"];
  organizationId: string;
}): Promise<VersionCategoryRaw> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.get<{ item: VersionCategoryRaw }>(
    `${apiUrlVersionCategories}/${versionCategoryId}`,
    {
      ...apiOrganizationIdParams,
    }
  );
  return response.data.item;
};

// カテゴリを作成
export const postCreateVersionCategory = async ({
  versionCategoryRawForm,
  organizationId,
}: {
  versionCategoryRawForm: VersionCategoryRawForm;
  organizationId: string;
}): Promise<VersionCategoryRaw> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.post<{ item: VersionCategoryRaw }>(
    `${apiUrlVersionCategories}`,
    versionCategoryRawForm,
    {
      ...apiOrganizationIdParams,
    }
  );
  return response.data.item;
};

// カテゴリを更新
export const postEditVersionCategory = async ({
  versionCategoryId,
  versionCategoryRawForm,
  organizationId,
}: {
  versionCategoryId: string;
  versionCategoryRawForm: VersionCategoryRawForm;
  organizationId: string;
}): Promise<VersionCategoryRaw> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.post<{ item: VersionCategoryRaw }>(
    `${apiUrlVersionCategories}/${versionCategoryId}`,
    versionCategoryRawForm,
    {
      ...apiOrganizationIdParams,
    }
  );
  return response.data.item;
};

// カテゴリを論理削除
export const postDisableVersionCategory = async ({
  versionCategoryId,
  organizationId,
}: {
  versionCategoryId: string;
  organizationId: string;
}): Promise<VersionCategoryRaw> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.post<{ item: VersionCategoryRaw }>(
    `${apiUrlVersionCategories}/${versionCategoryId}/delete`,
    undefined,
    {
      ...apiOrganizationIdParams,
    }
  );
  return response.data.item;
};

// 組織IDを指定してカテゴリを有効化
export const postEnableVersionCategory = async ({
  versionCategoryId,
  organizationId,
}: {
  versionCategoryId: string;
  organizationId: string;
}): Promise<VersionCategoryRaw> => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.post<{ item: VersionCategoryRaw }>(
    `${apiUrlVersionCategories}/${versionCategoryId}/enable`,
    undefined,
    {
      ...apiOrganizationIdParams,
    }
  );
  return response.data.item;
};

// カテゴリを物理削除
export const postRemoveVersionCategory = async ({
  versionCategoryId,
  organizationId,
}: {
  versionCategoryId: string;
  organizationId: string;
}) => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  await API_CLIENT.post<{ item: VersionCategoryRaw }>(
    `${apiUrlVersionCategories}/${versionCategoryId}/remove`,
    undefined,
    {
      ...apiOrganizationIdParams,
    }
  );
};

// 対象バージョンカテゴリの優先バージョンを設定
export const postSetPriorityVersion = async ({
  versionCategoryId,
  organizationId,
  versionId,
}: {
  versionCategoryId: string;
  organizationId: string;
  versionId?: string;
}) => {
  const { apiOrganizationIdParams } = getAPIConfigs(organizationId);
  const apiParams = {
    params: {
      ...apiOrganizationIdParams?.params,
      version: versionId,
    },
  };
  await API_CLIENT.post(
    `${apiUrlVersionCategories}/${versionCategoryId}/priority_version`,
    {},
    apiParams
  );
};
